import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { getProp } from '../Utils/formHelpers';
import { FormWrapperPropTypes } from '../Form/withForm';
import useForm from '../Hooks/useForm';
import useActivation from '../Hooks/useActivation';
import { getRandomId } from '../Utils/baseComponentHelper';

const resetHandler = () => { };

const Checkbox = ({
  addToForm,
  checked,
  className,
  defaultChecked,
  disabled: disabledProp, readOnly: readOnlyProp,
  indeterminate,
  name, label,
  onClick,
  switch: rSwitch,
  type,
  ...others
}) => {
  const {
    onFormChange,
    stato,
    notifica,
  } = useForm(name, resetHandler, true);

  const contesto = stato && name && getProp(name, stato);
  const { active, disabled, readOnly } = useActivation(disabledProp, readOnlyProp);
  const cbChecked = contesto || checked || defaultChecked || false;
  const uniqueid = useMemo(() => getRandomId(), []);

  const classes = cns(
    'checkbox',
    {
      'checkbox--switch': rSwitch,
      'checkbox--no-switch': !rSwitch,
      'checkbox--checked': cbChecked,
      'checkbox--enabled': active,
      'checkbox--indeterminate': indeterminate,
      'checkbox--readOnly': readOnly,
      'checkbox--disabled': disabled,
    },
    className,
  );

  const data = {};
  if (defaultChecked) {
    data.defaultChecked = defaultChecked;
  } else {
    data.checked = contesto || checked || false;
  }

  const labelClassName = cns(
    'checkbox__label',
    {
      'checkbox__label--disabled': disabled,
      'checkbox__label--readOnly': readOnly,
      'checkbox__label--checked': cbChecked,
    },
  );

  const inputConteinerClassName = cns(
    'checkbox__input-bg',
    {
      'checkbox__input-bg--switch': rSwitch,
      'checkbox__input-bg--no-switch': !rSwitch,
      'checkbox__input-bg--enabled': active,
    },
  );

  const handleChange = useCallback((e) => {
    if (active) notifica(e, name, e.target.checked, onClick, onFormChange, stato);
  }, [active, name, notifica, onClick, onFormChange, stato]);

  const checkboxId = `${name}_${uniqueid}`;
  return (
    <label className={classes} htmlFor={checkboxId}>
      <div className={inputConteinerClassName}>
        <input
          id={checkboxId}
          onChange={() => { }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...others}
          className={className}
          disabled={!active}
          onClick={handleChange}
          type="checkbox"
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...data}
        />
        <span />
      </div>
      {label && typeof label === 'string' && <span className={labelClassName}>{label}</span>}
      {typeof label !== 'string' && label}
    </label>
  );
};

Checkbox.defaultProps = {
  checked: false,
  className: '',
  defaultChecked: false,
  disabled: false,
  readOnly: false,
  indeterminate: false,
  name: '',
  onClick: null,
  switch: false,
  label: null,
};

Checkbox.propTypes = {
  ...FormWrapperPropTypes,
  /** Indica se la checkbox è checked */
  checked: PropTypes.bool,
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Indica se inizialmente la checkbox è checked ma non bindata */
  defaultChecked: PropTypes.bool,
  /** Indica se il componente è disabilitato */
  disabled: PropTypes.bool,
  /** Indica se il componente è readOnly */
  readOnly: PropTypes.bool,
  /** Indica se il componente è in stato indeterminato */
  indeterminate: PropTypes.bool,
  /** Nome del campo da bindare se il componente è contenuto all'interno di un componente Form */
  name: PropTypes.string,
  /** Etichetta da associare alla chackbox */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
Callback invocata al click sul componente:

dove:

- `evento`: evento scatenante
   */
  onClick: PropTypes.func,
  /** Indica se mostrare uno switch al posto della checkbox */
  switch: PropTypes.bool,
};

export default Checkbox;
